/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */

/* 该文件工具自动生成，请勿直接修改！！！ */

// @ts-ignore

import request from '@/utils/request/index';
/**
 * 接口 [发送短信验证码↗](https://yapi.fenxianglife.com/project/379/interface/api/42214) 的 **请求函数**
 *
 * @分类 [工具相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_9937)
 * @请求头 `POST /util/sms/code`
 * @更新时间 `2023-07-21 14:37:07`
 */
export const feimaChatUtilSmsCode = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatUtilSmsCodeRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.FeimaChatUtilSmsCodeResponse, OT>>(
    '/util/sms/code',
    'POST',
    data,
    options
  );

/**
 * 接口 [上传文件↗](https://yapi.fenxianglife.com/project/379/interface/api/42226) 的 **请求函数**
 *
 * @分类 [工具相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_9937)
 * @请求头 `POST /util/upload`
 * @更新时间 `2023-07-21 14:46:12`
 */
export const feimaChatUtilUpload = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatUtilUploadRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.FeimaChatUtilUploadResponse, OT>>(
    '/util/upload',
    'POST',
    data,
    options
  );

/**
 * 接口 [网页抓取↗](https://yapi.fenxianglife.com/project/379/interface/api/43198) 的 **请求函数**
 *
 * @分类 [工具相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_9937)
 * @请求头 `GET /util/html/content`
 * @更新时间 `2023-08-30 15:12:29`
 */
export const feimaChatUtilHtmlContent = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatUtilHtmlContentRequest>,
  options?: OT
) =>
  request<ToolTypes.GetResponseType<API.FeimaChatUtilHtmlContentResponse, OT>>(
    '/util/html/content',
    'GET',
    data,
    options
  );

/* prettier-ignore-end */
